<template>
  <div>
    <section class="menu__content clearfix">
      <section class="bills__wrapper">
        <section
          class="bills__side__wrapper"
          style="transform: translate3d(0px, 0px, 0px);"
        >
          <section class="col s12 m12">
            <section class="bills__categories__list animated">
              <section>
                <section>
                  <br />
                  <div
                    class="scrollbar-container ps-container ps-theme-default"
                  >
                    <section>
                      <section
                        class="bill__category__item clearfix first__item"
                      >
                        <h6 @click="solutionDropdown">
                          Our Solutions <i class="fa fa-caret-down"></i>
                        </h6>
                        <ul class="slideDown hide">
                          <router-link to="/irecharge_plus" class="slideoutNav">
                            <li class="waves-effect">
                              User
                            </li>
                          </router-link>
                          <router-link
                            to="/irecharge_merchant"
                            class="slideoutNav"
                          >
                            <li class="waves-effect">
                              Merchant
                            </li>
                          </router-link>
                          <router-link to="/irecharge_api" class="slideoutNav">
                            <li class="waves-effect">
                              API
                            </li>
                          </router-link>
                          <router-link
                            to="/irecharge_corporate"
                            class="slideoutNav"
                          >
                            <li class="waves-effect">
                              Corporate
                            </li>
                          </router-link>
                          <router-link
                            to="/irecharge_perks"
                            class="slideoutNav"
                          >
                            <li class="waves-effect">
                              Perks
                            </li>
                          </router-link>
                        </ul>
                        <router-link
                          to="/irecharge_pay"
                          style="color: #fff"
                          v-if="userType == 1"
                        >
                          <h6>iRecharge Pay</h6>
                        </router-link>
                        <router-link to="/request_token" style="color: #fff">
                          <h6>Lost your token?</h6>
                        </router-link>
                        <router-link to="/about" style="color: #fff">
                          <h6>About Us</h6>
                        </router-link>
                        <router-link
                          to="/terms-and-condition"
                          style="color: #fff"
                        >
                          <h6>Terms &amp; Condition</h6>
                        </router-link>
                      </section>
                    </section>
                  </div>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
    </section>
  </div>
</template>
<script>
export default {
  mounted() {
    this.getUserType()
  },
  data() {
    return {
      userType: ''
    }
  },
  methods: {
    solutionDropdown() {
      $('.slideDown').toggleClass('hide')
    },
    getUserType() {
      this.userType = localStorage.getItem('userType')
    }
  }
}
</script>
<style scoped>
.bill__category__item ul a.router-link-exact-active,
.sidenav a.router-link-exact-active {
  background-color: #1cab60;
}
.bill__category__item ul a li {
  color: #fff;
  padding: 15px 25px;
  width: 100%;
}
.bill__category__item ul a {
  padding: 15px 0px;
  text-align: left;
}
.bill__category__item ul a .waves-effect {
  display: block;
}
.bill__category__item ul a li:hover {
  background-color: #ffa07a;
}
.hide {
  display: none;
}
</style>
